import React from 'react'
import I18n from 'i18n-react'

import String from './fields/String'
import { Popover } from '../../../../Components'
import Loader from './Loader'

const FormClient = (props) => {
  const { combinedValidationErrors, imagePath, fetching } = props

  return (
    <div className="container timeline-container mb-4">
      <div className="form-group fromClient">
        <div className="fromClient__content-body">
          <div className="fake-bg" />
          <div className="row">
            <div className="col-12">
              <div className="">
                <h3 className="fromClient__info-title">{I18n.translate('vehicleInfoGeneral.fromClient.title')}</h3>
                <p className="fromClient__info-text">{I18n.translate('vehicleInfoGeneral.fromClient.description')}</p>
                <p className="fromClient__info-subtitle">{I18n.translate('vehicleInfoGeneral.fromClient.subtitle')}</p>
              </div>

              <div
                className={`row justify-content-center mb-4 ${
                  props.rzOrVinRequired && !props.pushIsPristine ? 'is-invalid' : ''
                }`}
              >
                <div className="col-12 mb-4">
                  <div className="custom-input">
                    <div className="custom-input__content">
                      <div className="row custom-input__row align-items-center">
                        <div className="col-12 col-md-7 w-100 d-flex align-items-center">
                          <String
                            className="custom-input__item form-control mw-auto"
                            id="vinRz"
                            invalidClassName="invalid-tooltip mt-0 cursor-pointer invalid-cebia"
                            isPristine={props.pushIsPristine}
                            maxLength={17}
                            name="vinRz"
                            onBlur={props.handleOnBlur}
                            onChange={props.handleChange}
                            onErrorChange={props.handleChangeValidationError}
                            placeholder={I18n.translate(`vehicleInfoGeneral.fields.vinRz.placeholder`)}
                            required
                            validationErrors={combinedValidationErrors}
                            value={props.data.vinRz}
                          />
                        </div>
                        <div className="col-12 col-md-5 mt-3 mt-md-0">
                          <button
                            className="btn fromClient__find-btn px-1"
                            disabled={fetching}
                            onClick={props.handleSubmit}
                            tabIndex="2"
                            type="submit"
                          >
                            {!fetching ? (
                              <div className="fromClient-button__icon">
                                <i className="btn-icon pfp pfp-car" />
                              </div>
                            ) : (
                              <Loader active className="vehicleInfo-loader" key="vehicleInfo-loader" small />
                            )}
                            <span>{I18n.translate(`vehicleInfoGeneral.fromClient.findVehicle`)}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 d-flex align-items-center justify-content-between flex-column flex-xl-row pt-2">
                  <div className="d-flex align-center flex-column flex-sm-row mb-4 mb-xl-0 footer-wrapper">
                    <button
                      className="btn fromClient__info-btn px-1 mb-3 mb-sm-0"
                      onClick={props.handleShowCalculator}
                      tabIndex="2"
                      type="submit"
                    >
                      <div className="fromClient-button__icon">
                        <i className="btn-icon pfp pfp-document" />
                      </div>
                      <span>{I18n.translate(`vehicleInfoGeneral.fromClient.fill`)}</span>
                    </button>
                    <button
                      className="btn fromClient__info-btn px-1"
                      onClick={props.handleShowCalculator}
                      tabIndex="2"
                      type="submit"
                    >
                      <div className="fromClient-button__icon">
                        <i className="btn-icon pfp pfp-car" />
                      </div>
                      <span>{I18n.translate(`vehicleInfoGeneral.fromClient.otherCar`)}</span>
                    </button>
                  </div>
                  <div>
                    <Popover
                      content={I18n.translate('vehicleInfoGeneral.fromClient.tooltip.content')}
                      id="TODO"
                      popoverText={I18n.translate('vehicleInfoGeneral.fromClient.tooltip.title')}
                      templateVariables={{}}
                      title={I18n.translate('vehicleInfoGeneral.fromClient.tooltip.title')}
                    />
                  </div>
                </div>
                {props.rzOrVinRequired && !props.pushIsPristine && (
                  <div className="invalid-tooltip">
                    <span>{I18n.translate('vehicleInfoGeneral.fromClient.rz')}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <img alt="robot" className="spz-image" src={`${imagePath}/robot-spz.png`} />
        </div>
      </div>
    </div>
  )
}

export default FormClient
